import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';

import Input from './SelectInput';
import Icon from '../Icon';
import { DropDownIconComponent } from './icons';

import styles, {analyzeTemplate, select_class_for_menu} from './common_styles';

import MenuProps from './menuProps';

const NativeSelect = ({
    classes: {
      formControl,
      formControl_with_border,
      colorSecondary,
      checked,
      disabled,
      select,
      setBold,
      root,
      rootOpen,
      menuItem,
      listItemText,
      disable_padding_right,
      selected,
      ...other_classes
    },
    selected_value,
    values,
    handleChange,
    name,
    open,
    handleOpen,
    handleClose,
    icon_component,
    icon_adornment_size,
    select_disabled,
    im_hovered_upon,
    selected_field,
    dropdown_icon,
    dropdown_tooltip_text,
    type,
    input_class,
    className,
    full_width_xs,
    drop_down_menu_button,
    menuProps,
    ...props
  }) => {
//                ${full_width_xs ? other_classes[`full_width_input${icon_component ? `_${icon_adornment_size}` : ''}`]:""}
    return (
        <Select
          value={selected_value}
          onChange={handleChange}
          disabled = {select_disabled}

          input={
            <Input
              id="select-native-button"
              className = {(im_hovered_upon && !drop_down_menu_button) ? rootOpen : ''}
              input_class = {`
                ${(input_class || "")}
              `}
              iconComponent = {
                Boolean(icon_component && !(type === "icon")) ?
                <Icon
                  size = {icon_adornment_size}
                  type = {icon_component}
                  disabled = {select_disabled}
                /> : null
            }
          />
        }
        IconComponent = {
          () =>
          <DropDownIconComponent
              size = {type === "icon" ? "md" : "sm"}
              select_disabled = {select_disabled}
              dropdown_icon = {dropdown_icon}
              dropdown_tooltip_text = {dropdown_tooltip_text}
              is_button = {drop_down_menu_button}
          />
        }
        renderValue={selected => analyzeTemplate(selected_field, selected, type)}
        MenuProps={
          MenuProps({
            paper_class: select_class_for_menu({
              direction: type === "icon" ? "right" : "left",
              fullWidth: full_width_xs,
              classes: other_classes,
              no_adornment: !Boolean(icon_component)
            }),
            direction: type === "icon" ? "right" : "left",
            ...menuProps
          })
        }
        name = {name}
        classes = {{
          root,
          select: select + (type === "icon" ? ` ${disable_padding_right}` : '')
        }}
        onClick = {e => handleOpen(e, select_disabled)}
        open = {open}
        onClose={handleClose}
        onOpen={handleOpen}
        {...props}
      >
        {
          values.map(name => (
            <MenuItem
              key={name}
              value={name}
              classes = {{
                root: menuItem,
                selected
              }}
            >
              <ListItemText
                  primary={name}
                  value= {name}
                  name= {name}
                  aria-label= {name}
                  classes = {{
                    root: listItemText,
                    primary: name === selected_value ? setBold: ''
                  }}
                />
            </MenuItem>
          ))
        }
      </Select>
    );
}

NativeSelect.propTypes = {
  classes: PropTypes.shape({
    formControl: PropTypes.string.isRequired,
    formControl_with_border: PropTypes.string.isRequired,
    colorSecondary: PropTypes.string.isRequired,
    checked: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
    select: PropTypes.string.isRequired,
    setBold: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    rootOpen: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired

  }),
  selected_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  values: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  open: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon_component: PropTypes.string,
  icon_adornment_size: PropTypes.oneOf(['xs','sm','md','lg','xl']),
  select_disabled: PropTypes.bool,
  im_hovered_upon: PropTypes.bool,
  selected_field: PropTypes.string,
  dropdown_icon: PropTypes.string,
  input_class: PropTypes.string,
  full_width_xs: PropTypes.bool,
  drop_down_menu_button: PropTypes.bool
}

NativeSelect.defaultProps = {
  values: [],
  selected_value:'',
  icon_adornment_size: 'md',
  selected_field: 'selected',
  dropdown_icon: "icon-down-arrow"
}

export default React.memo(withStyles(styles)(NativeSelect));
